import styled from 'styled-components';

import { rem } from '../../core';

const ContentStyled = styled.div`
  h1, h2 {
    margin-bottom: ${rem(13)};
  }
  p {
    margin-bottom: ${rem(16)};
  }
`;

export default ContentStyled;
